import React from "react";

const STEPS = [
  { n: 1, title: "Sign in", desc: "We activate your account on WhatsApp within 5 minutes." },
  { n: 2, title: "Create match", desc: "Enter team names, overs, venue. 30 seconds." },
  { n: 3, title: "Setup teams", desc: "Colors, logos, lineups. Once per match." },
  { n: 4, title: "Copy overlay URL", desc: "Paste into vMix / OBS as a Browser Source." },
  { n: 5, title: "Score live", desc: "Click every ball. Overlay updates instantly." },
];

export default function HowItWorks() {
  return (
    <section className="py-20 max-w-6xl mx-auto px-6">
      <div className="text-center mb-14">
        <h2 className="font-heading text-4xl md:text-5xl font-black uppercase">Go live in 5 steps</h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-5 gap-4">
        {STEPS.map((s) => (
          <div key={s.n} className="p-5 rounded-xl bg-slate-800/50 border border-slate-700">
            <div className="w-10 h-10 rounded-full bg-blue-600 font-heading font-black text-white flex items-center justify-center text-lg">{s.n}</div>
            <div className="font-heading font-extrabold text-white mt-3 uppercase">{s.title}</div>
            <div className="text-slate-400 text-sm mt-1">{s.desc}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
